// Model
import model from '../../database/model/model.database';

// Name
import NAME from './name.database.driver';

export default model(NAME);
